import { createPortal, useRef } from 'preact/compat'
import { useEffect } from 'preact/hooks'

export const SearchHeader = ({ query, totalResults, isLoading, corrections, results }) => {
  const searchHeader = document.querySelector('#search-results')
  const content = useRef(searchHeader ? searchHeader.innerHTML : '')
  const hasMounted = useRef(false)

  const resultsReady = !isLoading && Array.isArray(results?.results)

  useEffect(() => {
    if (!resultsReady || totalResults !== 0) return

    const raf = requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        document.querySelectorAll('.flickity-enabled').forEach((element) => {
          const instance = element.flickity
          if (!instance) return
          try {
            instance.resize()
            instance.reloadCells()
          } catch {}
        })
      })
    })

    return () => cancelAnimationFrame(raf)
  }, [resultsReady, totalResults])

  if (!searchHeader) {
    return null
  }

  if (!hasMounted.current) {
    hasMounted.current = true
    searchHeader.innerHTML = ''
  }

  return createPortal(
    resultsReady && (
      <div className="flex flex-col items-center justify-center gap-y-1 w-full text-center" data-results={totalResults}>
          <h2 className="w-full paragraph-2xl font-extended-bold uppercase overflow-hidden text-ellipsis">
              {totalResults === 0 ? 'No' : totalResults} Results For "{corrections?.corrected ? corrections?.corrected : query}"
          </h2>
          {corrections?.corrected && (
              <div className="paragraph-s">
                  <p>No results found for "{query}". Showing results for "{corrections.corrected}" instead.</p>
              </div>
          )}
          {corrections?.didYouMean && (
              <div className="paragraph-s">
                  <p>Did you mean: <a href={`/search?query=${corrections.didYouMean}`} className='link-fade' aria-label={`Search for ${corrections.didYouMean}`}>{corrections.didYouMean}</a></p>
              </div>
          )}
          {totalResults === 0 && (
              <div className={'[&>div]:!block'} dangerouslySetInnerHTML={{ __html: content.current }} />
          )}
      </div>
    ), searchHeader
  )
}
